import * as types from '../actiontypes';
import utility from '../../util/utilityfunctions';
import Env from '../../util/env';
import {promiseAreas, serviceURL} from '../../util/uiconstants';

export function createAccessGroup(url, payload) {
	return {
		type: types.ADD_GROUP,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload,
				trackWithArea: promiseAreas.ACCESS_GROUP_AREA
			}
		},
		payload: payload
	};
}

export function updateAccessGroup(url, payload) {
	return {
		type: types.UPDATE_GROUP,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: payload,
				trackWithArea: promiseAreas.ACCESS_GROUP_AREA
			}
		}
	};
}

export function deleteAccessGroup(url) {
	return {
		type: types.DELETE_GROUP,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		}
	};
}

export function getProjectAccessGroups(url, payload) {
	return {
		type: types.GET_PROJECT_GROUPS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_PROJECT_GROUPS_AREA
			}
		}
	};
}

export function getAllAccessgroups(projectId) {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}/Groups`;
	return {
		type: types.GET_ALL_GROUPS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_PROJECT_GROUPS_AREA
			}
		}
	};
}

export function setEditAccessGroupMode(value) {
	return {
		type: types.SET_EDIT_ACCESSGROUP,
		value
	};
}

export function setMultiSelectMode(value) {
	return {
		type: types.SET_MULTI_SELECT,
		value
	};
}

export function copyAccessGroup(url, payload, oldGroupId) {
	return {
		type: types.COPY_GROUP,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload,
				trackWithArea: promiseAreas.COPY_GROUP_AREA
			}
		},
		payload: payload,
		oldGroupId
	};
}

export function editAccessGroupLocal(payload, groupId) {
	return {
		type: types.EDIT_GROUP_LOCAL,
		payload: payload,
		groupId
	};
}

export function deleteAccessGroupLocal(groupId) {
	return {
		type: types.DELETE_GROUP_LOCAL,
		groupId
	};
}

export function clearAllAccessGroups() {
	return {
		type: types.CLEAR_ALL_GROUPS
	};
}
